import { useEffect } from "react";
import { useAtom } from "jotai";
import { isCollapsedAtom, isCollapsedHoveredStateAtom } from "@/store/sidebar";
import { GetSidebarStateUseCase, ResetSidebarStateUseCase, SaveSidebarStateUseCase } from "@/core/usecases/sidebar";
import { SidebarStateRepository } from "@/infrastructure/repositories/sidebarState";

export const useSidebar = () => {
  const sidebarRepository = new SidebarStateRepository();
  const getSidebarState = new GetSidebarStateUseCase(sidebarRepository);
  const saveSidebarState = new SaveSidebarStateUseCase(sidebarRepository);
  const resetSidebarState = new ResetSidebarStateUseCase(sidebarRepository);

  // Sidebar collapse state
  const [isCollapsedSidebar, setIsCollapsedSidebar] = useAtom(isCollapsedAtom);
  const [isCollapsedSidebarHovered, setIsCollapsedSidebarHovered] = useAtom(isCollapsedHoveredStateAtom);

  useEffect(() => {
    const loadState = async () => {
      const savedState = await getSidebarState.execute();
      if (savedState) {
        setIsCollapsedSidebar(savedState.isCollapsed);
      }
    };
    loadState();
  }, []);

  useEffect(() => {
    const saveState = async () => {
      if (isCollapsedSidebar === null || isCollapsedSidebar === undefined) return;
      await saveSidebarState.execute({ isCollapsed: isCollapsedSidebar ?? false });
    };
    saveState();
  }, [isCollapsedSidebar]);

  const toggleCollapseSidebar = () => {
    const newIsCollapsedSidebar = !isCollapsedSidebar;
    if (newIsCollapsedSidebar) {
      setIsCollapsedSidebarHovered(false);
    }
    setIsCollapsedSidebar(newIsCollapsedSidebar);
  };

  const expandSidebar = () => {
    setIsCollapsedSidebar(false);
  };

  const collapseSidebar = () => {
    setIsCollapsedSidebar(true);
  };

  const resetSidebar = async () => {
    await resetSidebarState.execute();
    const defaultState = await getSidebarState.execute();
    setIsCollapsedSidebar(defaultState.isCollapsed);
  };

  // Sidebar collapse hover state

  const handleSidebarHover = (isHovered: boolean) => {
    setIsCollapsedSidebarHovered(isHovered);
  };

  return {
    isCollapsedSidebar,
    isCollapsedSidebarHovered,
    toggleCollapseSidebar,
    expandSidebar,
    collapseSidebar,
    resetSidebar,
    handleSidebarHover,
  };
};
